import { Files, Search, GitBranch, User, Settings } from "lucide-react";

export const ActivityBar = ({ explorerOpen, setExplorerOpen }) => {
  return (
    <div
      data-testid="ide-activity-bar"
      className="hidden sm:flex w-12 shrink-0 flex-col items-center py-3 gap-1 bg-[var(--activity)] border-r border-[var(--border)]"
    >
      <button
        data-testid="activity-files-btn"
        onClick={() => setExplorerOpen(!explorerOpen)}
        className={`p-2.5 border-l-2 ${explorerOpen ? "border-[#FF5722] text-[var(--text)]" : "border-transparent text-[var(--muted)]"} hover:text-[var(--text)] transition-colors`}
        aria-label="Explorer"
      >
        <Files size={20} />
      </button>
      <button className="p-2.5 border-l-2 border-transparent text-[var(--muted)] hover:text-[var(--text)] transition-colors" aria-label="Search">
        <Search size={20} />
      </button>
      <button className="p-2.5 border-l-2 border-transparent text-[var(--muted)] hover:text-[var(--text)] transition-colors" aria-label="Git">
        <GitBranch size={20} />
      </button>
      <div className="flex-1" />
      <button className="p-2.5 text-[var(--muted)] hover:text-[var(--text)] transition-colors" aria-label="Account">
        <User size={20} />
      </button>
      <button className="p-2.5 text-[var(--muted)] hover:text-[var(--text)] transition-colors" aria-label="Settings">
        <Settings size={20} />
      </button>
    </div>
  );
};
